<div id="capAlertFiltersDialog">
  <h2
    mat-dialog-title
    id="dialog-title"
    class="cap-alert-filters-dialog__title"
  >
    Edit filters
  </h2>

  <mat-dialog-content>
    <form
      id="filtersContainer"
      class="cap-alert-filters-dialog__form"
      [formGroup]="form"
      (ngSubmit)="save()"
    >
      <div class="cap-alert-filters-dialog__text-fields">
        @for (item of csvFields; track item.field) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ item.label }}</mat-label>
            <input
              matInput
              type="text"
              autocomplete="off"
              [id]="item.field"
              [formControlName]="item.field"
            />
          </mat-form-field>
        }
      </div>

      @for (group of groups; track group.field) {
        <fieldset class="cap-alert-filters-dialog__group">
          <legend class="cap-alert-filters-dialog__legend">
            {{ group.legend }}
          </legend>
          <div class="cap-alert-filters-dialog__options">
            @for (option of group.options; track option.key) {
              <mat-checkbox
                [id]="group.idPrefix + '-' + option.key"
                [checked]="isChecked(group.field, option.key)"
                (change)="setChecked(group.field, option.key, $event.checked)"
                >{{ option.label }}</mat-checkbox
              >
            }
          </div>
        </fieldset>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="cap-alert-filters-dialog__actions">
    <button
      rv-button
      variant="secondary"
      id="capAlertFiltersCancelButton"
      type="button"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      rv-button
      id="capAlertFiltersSaveButton"
      type="button"
      (click)="save()"
    >
      Save
    </button>
  </mat-dialog-actions>
</div>
